'use client';

import ComponentPage from 'components/pages/component_page';
import { useAppSelector } from 'lib/hooks';
import { selectUserDynamicValues } from 'slices/dynamicDataSelectors';
import { FormattedPage } from 'types/pages';
import { UserDynamicValues } from 'types/user';
import { devtoolsEnvironmentCheck } from 'utils/environmentCheck';

const DynamicPage = ({
  environment,
  page,
}: {
  environment: string;
  page: FormattedPage;
}) => {
  const userData = useAppSelector(selectUserDynamicValues) as UserDynamicValues;

  if (devtoolsEnvironmentCheck()) {
    // eslint-disable-next-line no-console
    console.log('Variables', userData);
  }

  const pageProps = { ...page.content, environment };

  return (
    <main>
      <ComponentPage {...pageProps} />
    </main>
  );
};

export default DynamicPage;
